import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Observable, throwError, BehaviorSubject } from 'rxjs';
//import { catchError, retry } from 'rxjs/operators';
import { Comment } from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class CommentService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    }

    public getCommentById(id: number) {
        return this.http.get<Comment>(this.baseUrl + 'api/Comment/GetCommentById/?id=' + id);
    }

    public saveComment(comment: Comment) {
        return this.http.post<Comment>(this.baseUrl + 'api/Comment/SaveComment/', comment, httpOptions);
    }
}